import { useMutation, useQueryClient } from '@tanstack/react-query';
import { booksManageService } from '../api/booksManageService';
import type { BulkQuotaUpdateDto, BulkStatusUpdateDto } from '../types/manageBooks';

export function useBulkBookActions() {
  const qc = useQueryClient();
  const invalidate = () => {
    void qc.invalidateQueries({ queryKey: ['manage-books'] });
  };

  const bulkStatus = useMutation({
    mutationFn: (input: BulkStatusUpdateDto) => booksManageService.bulkStatus(input),
    onSuccess: invalidate,
  });

  const bulkQuotas = useMutation({
    mutationFn: (input: BulkQuotaUpdateDto) => booksManageService.bulkQuotas(input),
    onSuccess: invalidate,
  });

  const bulkDelete = useMutation({
    mutationFn: (ids: string[]) => booksManageService.bulkDelete(ids),
    onSuccess: invalidate,
  });

  return { bulkStatus, bulkQuotas, bulkDelete };
}
